var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 88,
    viewBox: "0 0 75 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 72,
    height: 84,
    rx: 6.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8913 69.5V62.732L41.9153 41.42C42.9233 40.364 43.7153 39.38 44.2913 38.468C44.9153 37.556 45.3473 36.668 45.5873 35.804C45.8753 34.892 46.0193 33.98 46.0193 33.068C46.0193 31.196 45.2273 29.636 43.6433 28.388C42.1073 27.14 40.1393 26.516 37.7393 26.516C35.4353 26.516 33.2993 26.996 31.3313 27.956C29.3633 28.868 27.2033 30.452 24.8513 32.708L19.5233 26.228C22.3553 23.588 25.3073 21.62 28.3793 20.324C31.4513 18.98 34.6673 18.308 38.0273 18.308C41.4353 18.308 44.4353 18.908 47.0273 20.108C49.6193 21.308 51.6353 22.964 53.0753 25.076C54.5153 27.188 55.2353 29.66 55.2353 32.492C55.2353 34.124 54.9953 35.66 54.5153 37.1C54.0833 38.54 53.3633 40.004 52.3553 41.492C51.3473 42.932 50.0033 44.492 48.3233 46.172L33.0593 61.508L56.0273 61.436V69.5H20.8913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.cf011a1214bfe203aecc2f346efb49a0.svg";
export { ForwardRef as ReactComponent };